<div class="default-dialog-wrapper cob-dialog-wrapper">
	<div class="flex flex-col content">
		<div class="fixed-header">
			<div class="flex flex-row w-100-percent p-24 pl-20">
				<div class="flex flex-col basis-full">
					<div class="fw-700 mat-headline-5 mb-8 fs-12">{{ 'BLUEPRINT_SUMMARY.VIEW_DETAILS' | transloco | uppercase}}</div>
					<div class="mat-headline-5 fw-700 mb-4">{{ instance?.name }}</div>
				</div>
				<mat-icon svgIcon="close" class="cursor-pointer w-32 h-32" (click)="closeDialog()"></mat-icon>
			</div>
		</div>
		<div class="p-24">
			<div class="flex flex-col" *ngFor="let dynamicFormModel of dynamicFormModels">
				<div class="flex-row">
					<div class="basis-full mat-subtitle-2 fw-700 mb-12 fs-20">{{ dynamicFormModel?.property?.title }}</div>
				</div>
				<div class="flex flex-row flex-wrap">
					<div *ngIf="dynamicFormModel?.property?.type === InstallationSchemaPropertyType.ARRAY">
						<div *ngFor="let arrayItems of dynamicFormModel?.property?.items?.enum; let last = last;" class="mat-body-1 mb-8 overflow-wrap" [ngClass]="{'mb-16': last}">
							{{arrayItems}}
						</div>
					</div>
					<div class="flex-col w-50-percent mb-8" *ngFor="let property of dynamicFormModel?.property?.properties let i = index" [ngClass]="{'pl-30': (i % 2)}">
						<label class="overline-font letter-spacing fs-14 mb-6 mt-8">{{ property?.title | uppercase }}</label>
						<ng-container *ngIf="property?.type === InstallationSchemaPropertyType.ARRAY; else notArrayFormat">
							<ng-container *ngIf="property?.value?.length > 0; else hyphen">
								<div *ngFor="let arrayItems of property?.value; let last = last;" class="mat-body-1 mb-8 overflow-wrap" [ngClass]="{'mb-16': last}">
									{{arrayItems}}
								</div>
							</ng-container>
							<ng-template #hyphen>
								<div class="mb-8">-</div>
							</ng-template>
						</ng-container>
						<ng-template #notArrayFormat>
							<div class="mat-body-1 mb-8 overflow-wrap">{{property?.type===InstallationSchemaPropertyType.DATE? (property?.value | date:('dd MMM yyyy hh:mm')+ ' UTC') : typeOfPropertyValue(property?.value)? '-' : property?.value}}</div>
						</ng-template>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
